var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',[_vm._v("Count 组件")]),_c('p',[_vm._v("count 的值是： "+_vm._s(_vm.count))]),_c('button',{on:{"click":_vm.add}},[_vm._v("+1")])])}
var staticRenderFns = []

export { render, staticRenderFns }